"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

require("antd/es/popover/style/css");

var _popover = _interopRequireDefault(require("antd/es/popover"));

var _react = _interopRequireDefault(require("react"));

var _icons = require("@ant-design/icons");

require("./activity.scss");

const ActivityTooltip = props => {
  const {
    text,
    placement,
    warning,
    trigger
  } = props;

  const content = /*#__PURE__*/_react.default.createElement("p", {
    className: "activity-popover-content"
  }, text);

  return /*#__PURE__*/_react.default.createElement(_popover.default, {
    placement: placement,
    content: content,
    trigger: trigger || 'click'
  }, /*#__PURE__*/_react.default.createElement(_icons.InfoCircleOutlined, {
    style: warning ? {
      color: '#faad13'
    } : undefined
  }));
};

var _default = ActivityTooltip;
exports.default = _default;